import {
  TradingOffer,
  PartnerAgreedTradingOffer,
  TradingOfferType,
} from '../../../types/TradingOffer';
import {
  PartnerShares,
  PartnerActiveOffers,
  MarketInfo,
  ReferenceInfo,
  RecentActivity,
} from '../types/EquityMarketContextType';

export const mockedTradingOffers: TradingOffer[] = [
  {
    _id: '6601a1b2c3d4e5f6a7b80001',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80101',
      name: 'María García López',
    },
    shareClass: 'Clase A',
    documents: [],
    sharesCount: { total: 100, agreed: 40, approved: 20 },
    sharePrice: 50,
    startDate: '2025-12-01T00:00:00.000Z',
    endDate: '2026-03-31T00:00:00.000Z',
    type: TradingOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-11-28T10:00:00.000Z',
    updatedAt: '2026-01-15T14:30:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80002',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80102',
      name: 'Carlos Rodríguez Martín',
    },
    shareClass: 'Clase B',
    documents: ['64f0a1b2c3d4e5f6a7b8d001'],
    sharesCount: { total: 200, agreed: 200, approved: 200 },
    sharePrice: 55,
    startDate: '2025-11-15T00:00:00.000Z',
    endDate: '2026-02-15T00:00:00.000Z',
    type: TradingOfferType.SELL,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-11-10T09:00:00.000Z',
    updatedAt: '2026-01-10T11:20:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80003',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80103',
      name: 'Ana Fernández Ruiz',
    },
    shareClass: 'Clase A',
    documents: [],
    sharesCount: { total: 50, agreed: 5, approved: 0 },
    sharePrice: 48,
    startDate: '2025-12-20T00:00:00.000Z',
    endDate: '2026-06-20T00:00:00.000Z',
    type: TradingOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-12-18T16:45:00.000Z',
    updatedAt: '2026-01-05T08:10:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80004',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80104',
      name: 'Pedro Sánchez Vega',
    },
    shareClass: 'Clase A',
    documents: [],
    sharesCount: { total: 80, agreed: 44, approved: 30 },
    sharePrice: 47,
    startDate: '2025-12-01T00:00:00.000Z',
    endDate: '2026-02-28T00:00:00.000Z',
    type: TradingOfferType.BUY,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-11-29T12:00:00.000Z',
    updatedAt: '2026-01-20T17:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80005',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80105',
      name: 'Laura Díaz Moreno',
    },
    shareClass: 'Clase B',
    documents: ['64f0a1b2c3d4e5f6a7b8d002', '64f0a1b2c3d4e5f6a7b8d003'],
    sharesCount: { total: 100, agreed: 100, approved: 0 },
    sharePrice: 52,
    startDate: '2025-12-10T00:00:00.000Z',
    endDate: '2026-02-10T00:00:00.000Z',
    type: TradingOfferType.BUY,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-12-08T14:30:00.000Z',
    updatedAt: '2026-01-25T10:15:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80006',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80106',
      name: 'Inversiones Globales SL',
    },
    shareClass: 'Clase A',
    documents: [],
    sharesCount: { total: 500, agreed: 0, approved: 0 },
    sharePrice: 45,
    startDate: '2026-01-15T00:00:00.000Z',
    endDate: '2026-07-15T00:00:00.000Z',
    type: TradingOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2026-01-10T08:00:00.000Z',
    updatedAt: '2026-01-10T08:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80007',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80107',
      name: 'Javier Morales Torres',
    },
    shareClass: 'Clase C',
    documents: [],
    sharesCount: { total: 150, agreed: 150, approved: 150 },
    sharePrice: 60,
    startDate: '2025-10-01T00:00:00.000Z',
    endDate: '2025-12-31T00:00:00.000Z',
    type: TradingOfferType.BUY,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-09-28T11:00:00.000Z',
    updatedAt: '2025-12-20T16:45:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80008',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80108',
      name: 'Elena Navarro Gil',
    },
    shareClass: 'Clase B',
    documents: ['64f0a1b2c3d4e5f6a7b8d004'],
    sharesCount: { total: 75, agreed: 30, approved: 30 },
    sharePrice: 53,
    startDate: '2026-01-01T00:00:00.000Z',
    endDate: '2026-04-01T00:00:00.000Z',
    type: TradingOfferType.SELL,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2025-12-28T09:30:00.000Z',
    updatedAt: '2026-01-30T13:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80009',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80109',
      name: 'Capital Partners SA',
    },
    shareClass: 'Clase A',
    documents: [],
    sharesCount: { total: 300, agreed: 75, approved: 0 },
    sharePrice: 49,
    startDate: '2026-01-20T00:00:00.000Z',
    endDate: '2026-05-20T00:00:00.000Z',
    type: TradingOfferType.BUY,
    isPartialAmountEnabled: true,
    isSellerNameHidden: false,
    createdAt: '2026-01-18T15:00:00.000Z',
    updatedAt: '2026-02-01T10:00:00.000Z',
  },
  {
    _id: '6601a1b2c3d4e5f6a7b80010',
    society: '64f0a1b2c3d4e5f6a7b89999',
    partner: {
      _id: '64f0a1b2c3d4e5f6a7b80110',
      name: 'Roberto Iglesias Paz',
    },
    shareClass: 'Clase C',
    documents: [],
    sharesCount: { total: 25, agreed: 25, approved: 25 },
    sharePrice: 62,
    startDate: '2025-11-01T00:00:00.000Z',
    endDate: '2025-12-15T00:00:00.000Z',
    type: TradingOfferType.SELL,
    isPartialAmountEnabled: false,
    isSellerNameHidden: false,
    createdAt: '2025-10-30T07:00:00.000Z',
    updatedAt: '2025-12-14T18:00:00.000Z',
  },
];

export const mockedPartnerAgreedTradingOffers: PartnerAgreedTradingOffer[] = [
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80001',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80101',
      shareClass: 'Clase A',
      documents: [],
      sharesCount: { total: 100, agreed: 40, approved: 20 },
      sharePrice: 50,
      startDate: '2025-12-01T00:00:00.000Z',
      endDate: '2026-03-31T00:00:00.000Z',
      type: TradingOfferType.SELL,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-11-28T10:00:00.000Z',
      updatedAt: '2026-01-15T14:30:00.000Z',
    },
    sharesCount: { agreed: 20 },
    date: '2026-01-10T09:00:00.000Z',
    isApproved: true,
    documents: ['64f0a1b2c3d4e5f6a7b8d010'],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80004',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80104',
      shareClass: 'Clase A',
      documents: [],
      sharesCount: { total: 80, agreed: 44, approved: 30 },
      sharePrice: 47,
      startDate: '2025-12-01T00:00:00.000Z',
      endDate: '2026-02-28T00:00:00.000Z',
      type: TradingOfferType.BUY,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-11-29T12:00:00.000Z',
      updatedAt: '2026-01-20T17:00:00.000Z',
    },
    sharesCount: { agreed: 30 },
    date: '2026-01-05T14:20:00.000Z',
    isApproved: true,
    documents: [],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80002',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80102',
      shareClass: 'Clase B',
      documents: ['64f0a1b2c3d4e5f6a7b8d001'],
      sharesCount: { total: 200, agreed: 200, approved: 200 },
      sharePrice: 55,
      startDate: '2025-11-15T00:00:00.000Z',
      endDate: '2026-01-15T00:00:00.000Z',
      type: TradingOfferType.SELL,
      isPartialAmountEnabled: false,
      isSellerNameHidden: false,
      createdAt: '2025-11-10T09:00:00.000Z',
      updatedAt: '2026-01-10T11:20:00.000Z',
    },
    sharesCount: { agreed: 200 },
    date: '2025-12-22T11:00:00.000Z',
    isApproved: true,
    documents: ['64f0a1b2c3d4e5f6a7b8d011', '64f0a1b2c3d4e5f6a7b8d012'],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80005',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80105',
      shareClass: 'Clase B',
      documents: ['64f0a1b2c3d4e5f6a7b8d002', '64f0a1b2c3d4e5f6a7b8d003'],
      sharesCount: { total: 100, agreed: 100, approved: 0 },
      sharePrice: 52,
      startDate: '2025-12-10T00:00:00.000Z',
      endDate: '2026-02-10T00:00:00.000Z',
      type: TradingOfferType.BUY,
      isPartialAmountEnabled: false,
      isSellerNameHidden: false,
      createdAt: '2025-12-08T14:30:00.000Z',
      updatedAt: '2026-01-25T10:15:00.000Z',
    },
    sharesCount: { agreed: 100 },
    date: '2026-01-18T16:30:00.000Z',
    isApproved: false,
    documents: [],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80008',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80108',
      shareClass: 'Clase B',
      documents: ['64f0a1b2c3d4e5f6a7b8d004'],
      sharesCount: { total: 75, agreed: 30, approved: 30 },
      sharePrice: 53,
      startDate: '2026-01-01T00:00:00.000Z',
      endDate: '2026-04-01T00:00:00.000Z',
      type: TradingOfferType.SELL,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-12-28T09:30:00.000Z',
      updatedAt: '2026-01-30T13:00:00.000Z',
    },
    sharesCount: { agreed: 15 },
    date: '2026-01-28T10:45:00.000Z',
    isApproved: false,
    documents: ['64f0a1b2c3d4e5f6a7b8d013'],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80009',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80109',
      shareClass: 'Clase A',
      documents: [],
      sharesCount: { total: 300, agreed: 75, approved: 0 },
      sharePrice: 49,
      startDate: '2026-01-20T00:00:00.000Z',
      endDate: '2026-05-20T00:00:00.000Z',
      type: TradingOfferType.BUY,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2026-01-18T15:00:00.000Z',
      updatedAt: '2026-02-01T10:00:00.000Z',
    },
    sharesCount: { agreed: 75 },
    date: '2026-01-30T08:15:00.000Z',
    isApproved: false,
    documents: [],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80001',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80101',
      shareClass: 'Clase A',
      documents: [],
      sharesCount: { total: 100, agreed: 40, approved: 20 },
      sharePrice: 50,
      startDate: '2025-12-01T00:00:00.000Z',
      endDate: '2026-03-31T00:00:00.000Z',
      type: TradingOfferType.SELL,
      isPartialAmountEnabled: true,
      isSellerNameHidden: false,
      createdAt: '2025-11-28T10:00:00.000Z',
      updatedAt: '2026-01-15T14:30:00.000Z',
    },
    sharesCount: { agreed: 20 },
    date: '2026-01-22T13:40:00.000Z',
    isApproved: false,
    documents: [],
  },
  {
    tradingOffer: {
      _id: '6601a1b2c3d4e5f6a7b80007',
      society: '64f0a1b2c3d4e5f6a7b89999',
      partner: '64f0a1b2c3d4e5f6a7b80107',
      shareClass: 'Clase C',
      documents: [],
      sharesCount: { total: 150, agreed: 150, approved: 150 },
      sharePrice: 60,
      startDate: '2025-10-01T00:00:00.000Z',
      endDate: '2025-12-31T00:00:00.000Z',
      type: TradingOfferType.BUY,
      isPartialAmountEnabled: false,
      isSellerNameHidden: false,
      createdAt: '2025-09-28T11:00:00.000Z',
      updatedAt: '2025-12-20T16:45:00.000Z',
    },
    sharesCount: { agreed: 150 },
    date: '2025-12-15T17:00:00.000Z',
    isApproved: true,
    documents: ['64f0a1b2c3d4e5f6a7b8d014', '64f0a1b2c3d4e5f6a7b8d015'],
  },
];

export const mockedPartnerShares: PartnerShares = {
  total: 1250,
  acquisitionValue: 62500,
  avgAcquisitionPrice: 50,
  estimatedValue: 75000,
  valueChange: 20,
};

export const mockedPartnerActiveOffers: PartnerActiveOffers = {
  total: 3,
  sellCount: 2,
  buyCount: 1,
  sellAmount: 16000,
  buyAmount: 2940,
};

export const mockedMarketInfo: MarketInfo = {
  totalOffers: 5,
  sellCount: 3,
  buyCount: 2,
  sellAmount: 16000,
  buyAmount: 2940,
};

export const mockedReferenceInfo: ReferenceInfo = {
  lastValuation: 50,
  lastValuationDate: 'Dic 2024',
  totalShares: 12500,
  lastTransactionPrice: 49,
  lastTransactionDate: 'Hace 2 días',
  activePartnersInMarket: 8,
};

export const mockedRecentActivity: RecentActivity[] = [
  {
    _id: 'activity-001',
    type: TradingOfferType.SELL,
    sharesCount: 100,
    shareClass: 'Clase A',
    pricePerShare: 50,
    totalAmount: 5000,
    date: '2026-02-03T10:00:00.000Z',
    daysAgo: 'Hace 2 días',
  },
  {
    _id: 'activity-002',
    type: TradingOfferType.SELL,
    sharesCount: 50,
    shareClass: 'Clase B',
    pricePerShare: 52,
    totalAmount: 2600,
    date: '2026-01-31T14:30:00.000Z',
    daysAgo: 'Hace 5 días',
  },
  {
    _id: 'activity-003',
    type: TradingOfferType.BUY,
    sharesCount: 80,
    shareClass: 'Clase A',
    pricePerShare: 48,
    totalAmount: 3840,
    date: '2026-01-29T09:15:00.000Z',
    daysAgo: 'Hace 1 semana',
  },
  {
    _id: 'activity-004',
    type: TradingOfferType.SELL,
    sharesCount: 200,
    shareClass: 'Clase A',
    pricePerShare: 49,
    totalAmount: 9800,
    date: '2026-01-22T11:00:00.000Z',
    daysAgo: 'Hace 2 semanas',
  },
];
